import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import CacheRoute, { CacheSwitch } from "react-router-cache-route";
import { Cookies } from "react-cookie";
import { getAppData } from "assets/js/apphandle";
const cookies = new Cookies();

function AuthRoute({ component: Component, route: route, ...rest }) {
  let accessToken = "";
  let refreshToken = "";

  accessToken = cookies.get("X-AUTH-TOKEN");
  refreshToken = cookies.get("X-REFRESH-TOKEN");

  return (
    <>
      {route.cache == true ? (
        <CacheRoute
          {...rest}
          render={(props) =>
            !accessToken && !refreshToken ? (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { from: props.location },
                }}
              />
            ) : (
              <Component {...props} />
            )
          }
        />
      ) : (
        <Route
          {...rest}
          render={(props) =>
            !accessToken && !refreshToken ? (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { from: props.location },
                }}
              />
            ) : (
              <Component {...props} />
            )
          }
        />
      )}
    </>
  );
}

export default AuthRoute;
